<div class="py-2 px-3">
    <h1 mat-dialog-title>Create Role</h1>
    <div mat-dialog-content [formGroup]="form" class="p-2">
        <mat-form-field appearance="outline" class="role-name-field" hideRequiredMarker>
            <mat-label>Role Name <span class="red">*</span></mat-label>
            <input matInput formControlName="name" cdkFocusInitial (keydown.enter)="onSaveClick()">
            <mat-error *ngIf="form.get('name')?.invalid">Required</mat-error>
        </mat-form-field>
    </div>
    <div class="mt-2 mb-3 d-flex justify-content-end">
        <button mat-raised-button class="cancel-button" [disabled]="saving" (click)="onCancelClick()">
            <mat-icon>cancel</mat-icon>
            Cancel
        </button>
        <button mat-raised-button class="action-button" [disabled]="form.invalid || saving" (click)="onSaveClick()">
            <mat-spinner *ngIf="saving" diameter="18" class="btn-spinner"></mat-spinner>
            <mat-icon *ngIf="!saving">save</mat-icon>
            {{ saving ? 'Saving...' : 'Save' }}
        </button>
    </div>
</div>
